import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { useState } from 'react';
// @mui
import {
  Grid,
  Container,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Card,
  CardHeader,
  Box,
  Divider,
} from '@mui/material';
// sections
import {
  AppRtspList,
  AppWidgetSummary,
} from '../../sections/@dashboard/app';

// ----------------------------------------------------------------------

export default function NvStreamerDashboard() {
  const hostList = useSelector((state) => state.app.hostList);
  const cameraList = useSelector((state) => state.app.cameraList);
  const [vstDevice, setVstDevice] = useState(hostList.length > 0 ? hostList[0] : null);

  const handleVstDeviceChange = (e) => {
    setVstDevice(e.target.value);
  };

  return (
    <>
      <Helmet>
        <title> Dashboard | VST UI </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Hi, Welcome back
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6}>
            <AppWidgetSummary title={`${window.adaptorType} devices`} total={hostList.length} icon={'mdi:memory'} />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <AppWidgetSummary title="Video files" total={cameraList.length} color="info" icon={'lucide:file-video'} />
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
          </Grid>

          <Grid item xs={12}>
            <Card>
              <CardHeader title={`${window.adaptorType} devices`} subheader={`Select ${window.adaptorType} device`} />
              <Box sx={{ p: 3, pb: 1 }} dir="ltr">
                <FormControl>
                  <RadioGroup row name="vst-device-radio-button" value={vstDevice} onChange={handleVstDeviceChange}>
                    {hostList.map((host) => (
                      <FormControlLabel value={host} control={<Radio />} label={`${window.adaptorType} ${host}`} key={host} />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <AppRtspList
              title="RTSP URLs"
              subheader="Click on entries to copy RTSP URL"
              host={vstDevice}
              rowCount={5}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
